/** Bump when replacing homepage files at the same path.
 *  6: form-factor posters moved to /web_v2/home-v4/form-factors/. */
const HOME_ASSET_VERSION = '6';

export function homeAssetSrc(src: string): string {
  const join = src.includes('?') ? '&' : '?';
  return `${src}${join}v=${HOME_ASSET_VERSION}`;
}
